import apiRequest from "../../functions/api";

export const postMeldungKenntnisnahme = (client, accessToken, habwKey, onlineId) => {
  return new Promise((resolve, reject) => {
    const payload = {
      mandant: client,
      program: "PMURA3",
      statement: "MELDUNG_ZUR_KENNTNIS_NEHMEN",
      habwKey,
      onlineId
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest(
      "POST",
      "daten",
      payload,
      headers,
      (response) => {
        if (response.status === 200 && response.data.message === "OK") {
          resolve(response.data);
        } else {
          if (response) {
            reject(response.data.message);
          } else {
            reject("Keine Internetverbindung");
          }
        }
        resolve();
      },
      () => {
        reject("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
      }
    );
  });
};
